import styles from "./EmptyState.module.css";

/**
 * Shared empty state (PRD §42).
 * Always says what is missing and, where possible, what to do instead.
 */
const EmptyState = ({
  title = "No games right now.",
  message,
  icon = "fa-regular fa-calendar",
  action,
  className = "",
}) => (
  <div className={`${styles.EmptyState} ${className}`.trim()}>
    <span className={styles.icon} aria-hidden="true">
      <i className={icon} />
    </span>
    <p className={styles.title}>{title}</p>
    {message && <p className={styles.message}>{message}</p>}
    {action && <div className={styles.action}>{action}</div>}
  </div>
);

export default EmptyState;
